<template>
  <div />
</template>

<script>
import { Toast } from 'vant'
export default {
  data () {
    return {
    }
  },
  mounted () {
    Toast.loading({
      duration: 0,
      message: '加载中...',
      forbidClick: true,
    })
  },
  destroyed () {
    Toast.clear()
  },
}
</script>

<style lang="scss" scoped>
</style>
